'use strict';

module.exports = toDate;

function toDate() {
    return [this.start.toDate(), this.end.toDate()];
}



// WEBPACK FOOTER //
// ./src/moment-wrange/lib/toDate.js